const features = [
  { icon: 'ri-timer-flash-line', title: '24-72 Saat Hız', desc: 'Ekspres sevkiyatlarda küresel hız garantisi. Geciken kargolarda tam iade politikası.' },
  { icon: 'ri-radar-line', title: 'Anlık GPS Takip', desc: 'Tüm araçlar GPS donanımlı. Web ve WhatsApp üzerinden canlı konum izleme.' },
  { icon: 'ri-headphone-line', title: '7/24 Türkçe Destek', desc: 'Uzman ekibimiz telefon, WhatsApp ve e-posta ile her zaman ulaşılabilir.' },
  { icon: 'ri-price-tag-3-line', title: 'Şeffaf Fiyat', desc: 'Gizli ücret yok. Hacim bazlı avantajlı fiyatlar, anlık online hesaplama.' },
  { icon: 'ri-shield-check-line', title: 'Sigortalı Taşıma', desc: 'Her sevkiyat sigorta kapsamında. Hasar veya kayıpta eksiksiz tazminat.' },
  { icon: 'ri-robot-line', title: 'AI Rota Motoru', desc: 'Yapay zeka ile en hızlı ve ekonomik rota otomatik belirleniyor.' },
  { icon: 'ri-file-list-3-line', title: 'Gümrük Uzmanlığı', desc: 'A.TR belgesi, gümrük beyannamesi ve mikro ihracat süreçleri eksiksiz.' },
  { icon: 'ri-link-m', title: 'API Entegrasyonu', desc: 'ERP ve e-ticaret platformlarınızı CargoNet\'e bağlayın. Tam otomasyon.' },
];

export default function WhyUsSection() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ background: 'var(--bg)', padding: '100px 0', borderTop: '1px solid var(--border)' }}
    >
      <div className="absolute pointer-events-none" style={{ top: '30%', right: '-8%', width: 500, height: 500, background: 'radial-gradient(circle, rgba(232,97,26,0.06) 0%, transparent 65%)', borderRadius: '50%' }}></div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-end mb-16">
          <div>
            <div className="label"><div className="label-dot"></div>Neden CargoNet?</div>
            <h2
              className="reveal h-font"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px, 4.5vw, 56px)', color: 'var(--text1)', lineHeight: 1.1 }}
            >
              Rekabeti değil,<br />
              <span className="text-gradient">farkı</span> hissedeceksiniz.
            </h2>
          </div>
          <div className="grid grid-cols-3 gap-6">
            {[
              { img: 'https://readdy.ai/api/search-image?query=professional%20logistics%20person%20portrait%20smiling%20diverse%20team%20dark%20background&width=80&height=80&seq=face1&orientation=squarish', n: 'Ahmet K.' },
              { img: 'https://readdy.ai/api/search-image?query=professional%20female%20business%20person%20portrait%20smiling%20dark%20background%20corporate%20headshot&width=80&height=80&seq=face2&orientation=squarish', n: 'Selin D.' },
              { img: 'https://readdy.ai/api/search-image?query=young%20male%20entrepreneur%20portrait%20confident%20smile%20modern%20dark%20background&width=80&height=80&seq=face3&orientation=squarish', n: 'Murat Ş.' },
            ].map((f, i) => (
              <div key={i} className={`reveal d${i + 1} text-center`}>
                <div className="w-12 h-12 rounded-full overflow-hidden mx-auto mb-2" style={{ border: '2px solid rgba(232,97,26,0.4)' }}>
                  <img src={f.img} alt={f.n} className="w-full h-full object-cover" />
                </div>
                <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)' }}>{f.n}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((f, i) => (
            <div
              key={i}
              className={`reveal d${Math.min(i + 1, 6)} card-dark group cursor-default p-6`}
            >
              <div
                className="w-10 h-10 flex items-center justify-center rounded-xl mb-4 transition-all duration-300 group-hover:scale-110"
                style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.2)' }}
              >
                <i className={`${f.icon} text-[#E8611A]`} style={{ fontSize: 18 }}></i>
              </div>
              <h3 style={{ fontWeight: 700, fontSize: 15, color: 'var(--text1)', marginBottom: 6 }}>{f.title}</h3>
              <p style={{ fontSize: 13, color: 'var(--text3)', lineHeight: 1.65 }}>{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 reveal">
          <div
            className="relative rounded-3xl overflow-hidden grad-border"
            style={{ height: 280 }}
          >
            <img
              src="https://readdy.ai/api/search-image?query=3d%20render%20of%20futuristic%20logistics%20control%20center%20with%20large%20holographic%20screens%20showing%20world%20map%20shipment%20tracking%20data%20dark%20room%20orange%20blue%20glow%20effects%20cinematic%20professional%20visualization&width=1400&height=280&seq=control3d&orientation=landscape"
              alt="Control Center"
              className="w-full h-full object-cover"
            />
            <div style={{ position: 'absolute', inset: 0, background: `linear-gradient(to right, var(--overlay-dark) 0%, var(--overlay-mid) 40%, var(--overlay-dark) 100%)` }}></div>
            <div className="absolute inset-0 flex items-center px-10 lg:px-16">
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--orange)', marginBottom: 8 }}>Teknoloji Altyapımız</div>
                <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(24px,3vw,40px)', color: '#fff', lineHeight: 1.1 }}>
                  AI destekli lojistik platformu<br />2025&apos;te devrede.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
